import { useTranslation } from 'react-i18next';
import { formatPrice } from '@/lib/formatPrice';

export default function SeminarOverview() {
  const { t } = useTranslation();

  const rows: { labelKey: string; valueKey: string; accent?: boolean; isHtml?: boolean }[] = [
    { labelKey: 'seminar.overview.row.duration', valueKey: 'seminar.overview.duration' },
    { labelKey: 'seminar.overview.row.hours', valueKey: 'seminar.overview.totalHours' },
    { labelKey: 'seminar.overview.row.price', valueKey: 'seminar.overview.price', accent: true },
    { labelKey: 'seminar.overview.row.capacity', valueKey: 'seminar.overview.capacity' },
    { labelKey: 'seminar.overview.row.location', valueKey: 'seminar.overview.location' },
    { labelKey: 'seminar.overview.row.target', valueKey: 'seminar.overview.target' },
    { labelKey: 'seminar.overview.row.schedule', valueKey: 'seminar.overview.scheduleHtml', isHtml: true },
  ];

  return (
    <section className="relative py-16 md:py-20 bg-background-50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-12">
          {String(t('seminar.overview.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-4">
            {t('seminar.overview.altTitle')}
          </h2>
          <div className="gold-line mx-auto"></div>
        </div>

        <div className="table-scroll overflow-hidden border border-background-200/80">
          <div className="overflow-x-auto">
            <table className="w-full sm:min-w-[600px]">
              <thead>
                <tr className="bg-primary-900">
                  <th className="w-[100px] sm:w-[160px] px-4 sm:px-6 py-4 text-left text-[14px] text-accent-400 tracking-[0.1em] font-medium font-heading">
                    {t('seminar.overview.tableCol.item')}
                  </th>
                  <th className="px-4 sm:px-6 py-4 text-left text-[14px] text-accent-400 tracking-[0.1em] font-medium font-heading">
                    {t('seminar.overview.tableCol.content')}
                  </th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, index) => (
                  <tr
                    key={index}
                    className={[
                      'border-t border-background-200/60',
                      index % 2 === 0 ? 'bg-background-100/50' : 'bg-background-50',
                    ].join(' ')}
                  >
                    <td className="px-4 sm:px-6 py-4 text-[15px] text-foreground-500 tracking-[0.06em] font-label whitespace-nowrap">
                      {t(row.labelKey)}
                    </td>
                    <td className={[
                      'px-4 sm:px-6 py-4 text-[16px] tracking-[0.04em] break-words',
                      row.accent ? 'text-accent-700 font-medium' : 'text-foreground-800',
                    ].join(' ')}>
                      {row.isHtml ? (
                        <span dangerouslySetInnerHTML={{ __html: t(row.valueKey) }} />
                      ) : row.accent ? (
                        <>¥{formatPrice(t(row.valueKey))}{t('seminar.overview.taxNote')}</>
                      ) : (
                        t(row.valueKey)
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {String(t('seminar.overview.footerNote')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[13px] text-foreground-500 tracking-[0.04em] mt-5 text-center">{__s}</p>))}
      </div>
    </section>
  );
}
